import { normalizeOptOutChannel } from '@/features/condition-builder';
import { isRecord } from '@/utils/objects';
import type { OptOutNode } from '../types';
import { toString } from './parse-helpers';

/**
 * Parse opt-out conditions.
 * Handles: { optout: { type: 'SMS', from, inverse } }
 *          { type: 'opt_out', number, channel, inverse }
 *          { type: 'opt_out', phoneNumber, channel, negate }  (a campaign filter row)
 */
export function parseOptOut(raw: Record<string, unknown>): OptOutNode | null {
  // Ember format: { optout: { type, from, inverse } }
  if ('optout' in raw && isRecord(raw.optout)) {
    const optout = raw.optout;
    return {
      type: 'opt_out',
      inverse: optout.inverse === true,
      channel: normalizeOptOutChannel(toString(optout.type)),
      sender: toString(optout.from),
    };
  }

  if (raw.type === 'opt_out') {
    return {
      type: 'opt_out',
      inverse: raw.inverse === true || raw.negate === true,
      channel: normalizeOptOutChannel(toString(raw.channel)),
      sender: toString(raw.number ?? raw.phoneNumber),
    };
  }

  return null;
}
